export function calculateRoas({
  revenue,
  spend,
}: {
  revenue: number;
  spend: number;
}) {
  return revenue / spend;
}

export function calculateCac({
  transactions,
  spend,
}: {
  transactions: number;
  spend: number;
}) {
  return spend / transactions;
}
